// extracted by mini-css-extract-plugin
export default {"scrollToTop":"ScrollToTop_scrollToTop__uLJ72","show":"ScrollToTop_show__bWL9L","arrow":"ScrollToTop_arrow__uK3n3"};